import React from 'react'
import * as Styled from './IndicatorFilter.styles'
import { Indicator } from 'components/molecules/NursingIndicator/partials'
import { Minus3, Plus3 } from '@aok/icon-functional'
import PropTypes from 'prop-types'
import { useTextContext } from 'hocs'

/**
 * clickable filter element (-/+) buttons
 * @param variant
 * @param rating
 * @param onChange
 * @returns {JSX.Element}
 * @constructor
 */
const IndicatorFilter = ({ variant = 'circle', rating, onChange }) => {
  const textContext = useTextContext()

  return (
    <Styled.IndicatorFilter>
      <div className='indicator-filter-controls'>
        <button
          className='icon-button'
          onClick={ () => onChange?.(rating === 1 ? false : rating - 1) }
          disabled={ !rating }>
          <Minus3 />
        </button>
        <div className='indicator-rating'>
          <Indicator rating={ rating } variant={ variant } isFilter />
        </div>
        <button
          className='icon-button'
          onClick={ () => onChange?.(rating ? rating + 1 : 1) }
          disabled={ variant === 'circle' ? rating === 5 : rating === 4 }>
          <Plus3 />
        </button>
      </div>
      <div className='indicator-filter-description'>
        {rating > 0 &&
          textContext[`nursingIndicator.overlay.indicator.prefix.${ variant }`]}
        {
          textContext[
            `nursingIndicator.indicator.${ variant }.${
              rating === 0 ? false : rating
            }`
          ]
        }
      </div>
    </Styled.IndicatorFilter>
  )
}

IndicatorFilter.propTypes = {
  variant: PropTypes.oneOf(['circle', 'square']),
  rating: PropTypes.oneOfType([PropTypes.number, PropTypes.bool]),
  onChange: PropTypes.func,
}

export default IndicatorFilter
